import platform from 'platform';

export const isMobile = ['Android', 'iOS'].some((os) => platform.os?.family?.includes(os))
    || platform.name?.includes('Mobile')
    || (navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)); // For iPads
